import * as React from "react"
import { connect } from "react-redux"

import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { GlobalState } from "../../../store"

interface OwnProps {
    label: string
}

interface StateProps {
    url: string
}

type Props = OwnProps & StateProps

export const HomeButton = ({ label, url }: Props): JSX.Element => (
    <>
        {!!url && (
            <ActionAnchor
                id="goToHomePage"
                title={label}
                href={url}
                actionType={ActionType.icon}
                extraClasses="is-inverted no-underline"
            >
                {Symbols.Home}
            </ActionAnchor>
        )}
    </>
)

const mapStateToProps = (state: GlobalState): StateProps => ({
    url: state.userInfo.homePageUrl,
})

export default connect(mapStateToProps, {})(HomeButton)
